const LAUNCH_PARAMS: CMxAPI.LaunchParams = {
  launchPoint: null,
  patientIdentifier: null,
  providerID: null,
  providerName: null,
  serviceDate: null,
  transactionIds: null,
  uclIds: null,
  visitNumber: null
};

const launch = {
  text: 'Starting CodaMetrix...',
  launchParams: { ...LAUNCH_PARAMS }
};

export { launch };
